var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallLightyellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 25.8333V23.6388C28.5 22.5483 27.8361 21.5678 26.8237 21.1628L24.1115 20.0779C22.8238 19.5629 21.3563 20.1208 20.736 21.3613L20.5 21.8333C20.5 21.8333 17.1667 21.1667 14.5 18.5C11.8333 15.8333 11.1667 12.5 11.1667 12.5L11.6387 12.264C12.8792 11.6437 13.4371 10.1762 12.9221 8.88848L11.8372 6.17629C11.4322 5.16387 10.4517 4.5 9.36125 4.5H7.16667C5.69391 4.5 4.5 5.69391 4.5 7.16667C4.5 18.9487 14.0513 28.5 25.8333 28.5C27.3061 28.5 28.5 27.3061 28.5 25.8333Z",
    stroke: "#EBD28D",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLightyellow);
export default __webpack_public_path__ + "static/media/call-lightyellow.6c446dc9ba8dd26709591207574956f5.svg";
export { ForwardRef as ReactComponent };